import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-cash-02',
  standalone: true,
  templateUrl: '../../assets/cash-02.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCash02Icon {}
